export const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:58426";
export const canopyPublicAlias =
  process.env.REACT_APP_CANOPY_PUBLIC_ALIAS || "veros-credit-sandbox";
